import React from 'react';
import MuiModal from '../../mui/MuiModal/MuiModal';
import { Button } from '../Button';

export type HeadsUpModalProps = {
	open: boolean;
	loading?: boolean;
	onGotIt: () => void;
	onGoBack: () => void;
	onClose: () => void;
};

export const HeadsUpModal: React.FC<HeadsUpModalProps> = ( {
	open,
	loading,
	onGotIt,
	onGoBack,
	onClose,
} ) => (
	<MuiModal
		canClose={ !loading }
		muiModalProps={ {
			open,
			slotProps: { paper: { 'data-cy': 'heads-up-modal' } },
			onClose,
		} }
		title='Heads Up.'
		description={
			<>
				This document will be marked as &ldquo;Sent.&rdquo; Your client will not
				receive an email because reminders are turned off. Any cc'd recipients
				and notification group member will still receive an email.
				<br />
				<br />
				Want to notify your client? Enable email notifications before sending.
			</>
		}
		controls={
			<>
				<Button
					variant='outlined'
					onClick={ onGoBack }
					disabled={ loading }
					data-cy='heads-up-go-back-button'
				>
					Go back
				</Button>
				<Button
					variant='contained'
					color='primary'
					onClick={ onGotIt }
					loading={ loading }
					data-cy='heads-up-got-it-button'
				>
					Okay
				</Button>
			</>
		}
	/>
);
